// extracted by mini-css-extract-plugin
export default {"r_l":"_35b1f90f44 _553fae39c5","t":"b42f829bca"};